import { BaseUniDriver } from '@wix/wix-ui-test-utils/base-driver';
import { baseUniDriverFactory } from '../../testkitUtils/unidriver';
import { UniDriver } from '@wix/wix-ui-test-utils/unidriver';
import { ToastSkin } from './types';
import { hasDataAttr, hasMobile } from '../../testkitUtils/utils';

export interface ToastDriver extends BaseUniDriver {
  isShown(): Promise<boolean>;
  isMobile(): Promise<boolean>;
  isSuccess(): Promise<boolean>;
  isError(): Promise<boolean>;
  isStatus(): Promise<boolean>;
  isPreview(): Promise<boolean>;
  getCloseButton(): Promise<UniDriver>;
  getMessage(): Promise<UniDriver>;
  isCloseButtonExists(): Promise<boolean>;
}

const hasSkin = async (base: UniDriver, skin: ToastSkin): Promise<boolean> => {
  return hasDataAttr(base, 'skin', skin);
};

const hasIsShown = async (base: UniDriver): Promise<boolean> => {
  return hasDataAttr(base, 'is-shown', 'true');
};

export const toastDriverFactory = (base: UniDriver): ToastDriver => {
  const getCloseButton = async () => base.$('[data-hook="closeButton"]');
  const getMessage = async () => base.$('[data-hook="message"]');

  return {
    ...baseUniDriverFactory(base),
    /* Shows is the animated toast visible at the moment ot not */
    isShown: () => hasIsShown(base),
    isMobile: () => hasMobile(base),
    /* Shows is the toast render with "success" skin */
    isSuccess: () => hasSkin(base, ToastSkin.success),
    /* Shows is the toast render with "error" skin */
    isError: () => hasSkin(base, ToastSkin.error),
    /* Shows is the toast render with "status" skin */
    isStatus: () => hasSkin(base, ToastSkin.status),
    /* Shows is the toast render with "preview" skin */
    isPreview: () => hasSkin(base, ToastSkin.preview),
    /* Shows is the toast render with close button (X icon) */
    isCloseButtonExists: async () => (await getCloseButton()).exists(),
    /* Returns close button driver. Can be used for interaction with close button, f.e. click etc */
    getCloseButton,
    /* Returns message driver. F.e can be used for checking proper message text */
    getMessage,
  };
};
